import {
  Box,
  Button,
  Image,
  Center,
  Flex,
  Text,
  VStack,
  useDisclosure,
} from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import Carousel from "@/components/carousel";
import { useNavigate } from "react-router-dom";

import Swiper, { SwipeRef } from "react-tiga-swiper";
import "react-tiga-swiper/dist/index.css";

import Banner1 from "@/assets/images/b1.jpg";
import Banner2 from "@/assets/images/b2.jpg";
import Banner3 from "@/assets/images/b3.jpg";
import Banner4 from "@/assets/images/b4.jpg";

import functionTitle from "@/assets/images/title2.png";
import WOW from "wowjs";
import "animate.css";

import F1 from "@/assets/images/f1.png";
import F2 from "@/assets/images/f2.png";
import F3 from "@/assets/images/f3.png";
import F4 from "@/assets/images/f4.png";
import F5 from "@/assets/images/f5.png";
import F6 from "@/assets/images/f6.png";
import F7 from "@/assets/images/f7.png";
import F8 from "@/assets/images/f8.png";
import Fh1 from "@/assets/images/fh1.jpg";
import Fh2 from "@/assets/images/fh2.jpg";
import Fh3 from "@/assets/images/fh3.jpg";
import Fh4 from "@/assets/images/fh4.jpg";
import Fh5 from "@/assets/images/fh5.jpg";
import Fh6 from "@/assets/images/fh6.jpg";
import Fh7 from "@/assets/images/fh7.jpg";
import Fh8 from "@/assets/images/fh8.jpg";

import { FiArrowRightCircle } from "react-icons/fi";
import { AiOutlineRollback } from "react-icons/ai";

import V1 from "@/assets/images/wzst.mp4";
import V2 from "@/assets/images/ctxr.mp4";
import V3 from "@/assets/images/mxxr.mp4";
import V4 from "@/assets/images/zpxr.mp4";
import V5 from "@/assets/images/cyrh.mp4";
import V6 from "@/assets/images/gqfd.mp4";
import V7 from "@/assets/images/tmth.mp4";
import V8 from "@/assets/images/txtz.mp4";

import titleThree1 from "@/assets/images/sn.png";
import titleThree2 from "@/assets/images/jz.png";
import titleThree3 from "@/assets/images/jg.png";
import titleThree4 from "@/assets/images/qt.png";
import titleThreeBg from "@/assets/images/title2_bg.png";

import Sn1 from "@/assets/images/sn1.jpg";
import Sn2 from "@/assets/images/sn2.jpg";
import Sn3 from "@/assets/images/sn333.jpg";
import Sn4 from "@/assets/images/sn4.jpg";
import Sn5 from "@/assets/images/sn5.jpg";
import Sn6 from "@/assets/images/sn6.jpg";
import Sn7 from "@/assets/images/sn7.jpg";
import Sn8 from "@/assets/images/sn8.jpg";

import JZ1 from "@/assets/images/jz11.jpg";
import JZ2 from "@/assets/images/jz12.jpg";
import JZ3 from "@/assets/images/jz21.jpg";
import JZ4 from "@/assets/images/jz22.jpg";
import JZ5 from "@/assets/images/jz31.jpg";
import JZ6 from "@/assets/images/jz32.jpg";
import JZ7 from "@/assets/images/jz41.jpg";
import JZ8 from "@/assets/images/jz42.jpg";

import JG1 from "@/assets/images/jg11.jpg";
import JG2 from "@/assets/images/jg12.jpg";
import JG3 from "@/assets/images/jg21.jpg";
import JG4 from "@/assets/images/jg22.jpg";
import JG5 from "@/assets/images/jg31.jpg";
import JG6 from "@/assets/images/jg32.jpg";
import JG7 from "@/assets/images/jg41.jpg";
import JG8 from "@/assets/images/jg42.jpg";

import QT1 from "@/assets/images/qt11.jpg";
import QT2 from "@/assets/images/qt12.jpg";
import QT3 from "@/assets/images/qt21.jpg";
import QT4 from "@/assets/images/qt22.jpg";
import QT5 from "@/assets/images/qt31.jpg";
import QT6 from "@/assets/images/qt32.jpg";
import QT7 from "@/assets/images/qt41.jpg";
import QT8 from "@/assets/images/qt42.jpg";

import xfIcon1 from "@/assets/images/xf_icon1.png";
import xfIcon2 from "@/assets/images/xf_icon2.png";
import xfIcon3 from "@/assets/images/xf_icon3.png";
import xfIcon4 from "@/assets/images/xf_icon4.png";
import xfIcon5 from "@/assets/images/xf_icon5.png";
import xfIcon6 from "@/assets/images/xf_icon6.png";
import CustomerService from "@/components/home/customerService";
import FeedbackPopover from "@/components/home/feedback";
import MessageMenu from "@/components/layout/header/messagemenu";

type functionListItem = {
  imgSrc: string;
  hoverImgSrc: string;
  title: string;
  prod: string;
};

const Home = () => {
  const images = [`${Banner1}`, `${Banner2}`, `${Banner3}`];
  const videos = [`${V1}`, `${V2}`, `${V3}`, `${V4}`, `${V5}`, `${V6}`, `${V7}`, `${V8}`];

  const navigate = useNavigate();
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const [currentVideoIndex, setCurrentVideoIndex] = useState<number>(0);
  const [isOpen, setIsOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [showContacts, setShowContacts] = useState(false);
  const [isInBanner, setIsInBanner] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [coords, setCoords] = useState({ x: 0, y: 0 });
  const messageControl = useDisclosure();

  const bannerRef = useRef<HTMLDivElement>(null);
  const title3Ref = useRef<HTMLDivElement>(null);

  const swiperRef1 = useRef<SwipeRef>(null);
  const swiperRef2 = useRef<SwipeRef>(null);
  const swiperRef3 = useRef<SwipeRef>(null);
  const swiperRef4 = useRef<SwipeRef>(null);

  const snRef = useRef<HTMLDivElement>(null);
  const jzRef = useRef<HTMLDivElement>(null);
  const jgRef = useRef<HTMLDivElement>(null);
  const qtRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const wow = new WOW.WOW({ live: false });
    wow.init();
  }, []);

  const functionList: functionListItem[] = [
    {
      imgSrc: `${F1}`,
      hoverImgSrc: `${Fh1}`,
      title: "文字绘图",
      prod: "输入文字，根据文字生成图片。",
    },
    {
      imgSrc: `${F2}`,
      hoverImgSrc: `${Fh2}`,
      title: "线稿生图",
      prod: "上传照片或者线稿，即可渲染成效果图。",
    },
    {
      imgSrc: `${F3}`,
      hoverImgSrc: `${Fh3}`,
      title: "模型渲染",
      prod: "上传模型或者线稿，即可渲染成效果图。",
    },
    {
      imgSrc: `${F4}`,
      hoverImgSrc: `${Fh4}`,
      title: "照片渲染",
      prod: "上传现场照片，即可快速完成设计方案。",
    },
    {
      imgSrc: `${F5}`,
      hoverImgSrc: `${Fh5}`,
      title: "创意融合",
      prod: "将结构创意与风格创意相融合。",
    },
    {
      imgSrc: `${F6}`,
      hoverImgSrc: `${Fh6}`,
      title: "高清放大",
      prod: "增强清晰度、内容、修复损坏元素、添加细节！",
    },
    {
      imgSrc: `${F7}`,
      hoverImgSrc: `${Fh7}`,
      title: "智能扩图",
      prod: "根据画面边界自动延展图像内容，扩大场景表现力。",
    },
    {
      imgSrc: `${F8}`,
      hoverImgSrc: `${Fh8}`,
      title: "图像拓展",
      prod: "根据比例或尺寸将图片内容外进行外拓。",
    },
  ];

  const handleMouseEnter = (index: number) => {
    setHoveredIndex(index);
  };
  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };
  const handleClickFunctionItem = (event: React.MouseEvent<HTMLDivElement, MouseEvent>, index: number) => {
    setCurrentVideoIndex(index);
    setIsOpen(true);
    setCoords({ x: event.clientX, y: event.clientY });
  };
  const handleCloseVideoBox = () => {
    setCurrentVideoIndex(0);
    setIsOpen(false);
  };

  const scrollToSn = () => {
    let anchorElement = snRef.current;
    if (anchorElement) {
        window.scrollTo({ top: anchorElement.offsetTop-170, behavior: "smooth" });
    }
  }
  const scrollToJz = () => {
    let anchorElement = jzRef.current;
    if (anchorElement) {
        window.scrollTo({ top: anchorElement.offsetTop-170, behavior: "smooth" });
    }
  }
  const scrollToJg = () => {
    let anchorElement = jgRef.current;
    if (anchorElement) {
        window.scrollTo({ top: anchorElement.offsetTop-170, behavior: "smooth" });
    }
  }
  const scrollToQt = () => {
    let anchorElement = qtRef.current;
    if (anchorElement) {
        window.scrollTo({ top: anchorElement.offsetTop-170, behavior: "smooth" });
    }
  }

  useEffect(() => {
    const handleScroll = () => {
      // 判断第三板块标题是否吸顶
      if (title3Ref.current  && window.pageYOffset > title3Ref.current.offsetTop+60) {
        setIsSticky(true);
      }
      if(snRef.current && window.pageYOffset < snRef.current.offsetTop){
        setIsSticky(false);
      }

      // 判断是否在banner区域
      if(bannerRef.current && window.scrollY+60 >= bannerRef.current.getBoundingClientRect().height){
        setIsInBanner(true);
      }else {
        setIsInBanner(false);
      }
    }; 

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleMouseMove = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    setMousePosition({ x: event.clientX, y: event.clientY });
  };
  useEffect(() => {
    if (document.body.clientWidth - mousePosition.x <= 445) {
      setShowContacts(true);
    } else {
      setShowContacts(false);
    }
  }, [mousePosition]);

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  return (
    <Box bg="#E6E6E6" overflow="hidden" onMouseMove={handleMouseMove}>
      <Box ref={bannerRef}>
        <Carousel images={images}></Carousel>
      </Box>
      
      <Box bg="#fff" pt="30px">
        <Box
          sx={{
            borderTop: "1px solid #E0E0E0",
            width: "288px",
            margin: "0 auto",
            padding: "10px 0",
            textAlign: "center",
            fontFamily: "Source Han Sans",
            fontSize: "12px",
            fontWeight: 300,
            lineHeight: "106%",
            textTransform: "uppercase",
            letterSpacing: "20px",
            color: "#E0E0E0",
          }}
        >
          ALDGPTAI
        </Box>
      </Box>
      <Box bg="#fff" h="185px"></Box>
      <Box bg="#fff">
        <Center
          mb="60px"
          textAlign="center"
          className="wow slideInUp"
          data-wow-duration="1s"
        >
          <Image maxW="100%" src={functionTitle} />
        </Center>

        <Box
          className="wow slideInRight"
          data-wow-duration="1s"
          data-wow-delay="1s"
          boxShadow="10px 15px 20px -10px rgba(0, 0, 0, 0.5)"
          sx={{
            position: "relative",
            width: "100%",
          }}
        >
          <Box bgColor="#E0E0E0" h="1px" mb="8px"></Box>

          <Flex h="calc(100vh - 180px)">
            {functionList.map((item, index) => (
              <Box
                flex={1}
                bgColor="#FCFCFC"
                border="1px solid #E6E6E6"
                key={index}
                p="20px"
                cursor="pointer"
                onMouseEnter={() => handleMouseEnter(index)}
                onMouseLeave={handleMouseLeave}
                onClick={(event) => handleClickFunctionItem(event, index)}
                _hover={{
                  boxShadow: "0 0 15px rgba(0, 0, 0, 0.1)",
                  zIndex: 1,
                }}
              >
                <Image
                  maxW="100%"
                  src={hoveredIndex === index ? item.hoverImgSrc : item.imgSrc}
                />
                <Box
                  color="#3A3A3A"
                  fontWeight={350}
                  fontSize="20px"
                  mb={4}
                  mt={10}
                  // textAlign="center"
                >
                  {item.title}
                </Box>
                <Box
                  color="#6A6A6A"
                  fontWeight={300}
                  lineHeight="25px"
                  fontSize="14px"
                >
                  {item.prod}
                </Box>
              </Box>
            ))}
          </Flex>
          {/* video */}
          <Flex
            w={"100%"}
            flexDirection="column"
            justifyContent="flex-start"
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              opacity: isOpen ? 1 : 0,
              height: "100%",
              bgColor: "#fff",
              zIndex: 1,
              transitionDelay: "1s",
              // transition: "all 1s ease-in-out",
              transition: "transform 1s, opacity 1s",
              transformOrigin: `${coords.x}px ${coords.y}px`,
              transform: isOpen ? "scaleX(1)" : "scaleX(0)",
              // borderRadius: isOpen ? "0" : "9999px",
              overflow: "hidden",
            }}
          >
            <Box>
              <Button
                variant="ghost"
                color="#6A6A6A"
                fontSize={"14px"}
                ml="20px"
                mb="10px"
                onClick={handleCloseVideoBox}
              >
                <AiOutlineRollback /> 返回
              </Button>
            </Box>
            <Box flex="1" minH="0">
              {videos.map((videoItem, index) => (
                <Box
                  h="100%"
                  key={index}
                  display={currentVideoIndex == index ? "block" : "none"}
                >
                  <video
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                    key={index}
                    autoPlay
                    loop
                    muted
                  >
                    <source src={videoItem} type="video/mp4" />
                  </video>
                </Box>
              ))}
            </Box>
            <Box textAlign="center" mb="20px" p="20px">
              <Button variant="ghost" color="#6A6A6A" fontSize={"24px"} lineHeight="30px" mb={4}>
                前往体验&nbsp;
                <FiArrowRightCircle fontSize={"18px"} />
              </Button>
              <Box color="#B9B9B9" fontSize={"14px"} lineHeight="20px">
                {functionList[currentVideoIndex].prod}
              </Box>
            </Box>
          </Flex>
        </Box>
      </Box>
      <Box h="185px"></Box>

      {/*  建筑-室内-景观-其它 */}
      <Box 
        w="100%"
        mb="130px" 
        bgColor="#E6E6E6" 
        ref={title3Ref}
        className="wow slideInUp"
        data-wow-duration="1s"
        sx={{
          position: isSticky ? 'fixed' : '',
          top: isSticky ? '60px' : '',
          zIndex: isSticky ? 1 : '',
        }}
      >
        <Flex
          width="720px" 
          height="110px"
          maxW="85%"
          margin="0 auto"
          pt="15px"
          pb="15px"
          boxSizing="border-box"
          backgroundImage={`url(${titleThreeBg})`}
          backgroundSize="100%"
          backgroundRepeat="no-repeat"
          backgroundPosition="center top 15px"
          justifyContent="space-around"
          alignItems= "flex-end">
          <img onClick={() => scrollToSn()} style={{maxWidth: "100%"}} src={titleThree1} />
          <img onClick={() => scrollToJz()} style={{maxWidth: "100%"}} src={titleThree2} />
          <img onClick={() => scrollToJg()} style={{maxWidth: "100%"}} src={titleThree3} />
          <img onClick={() => scrollToQt()} style={{maxWidth: "100%"}} src={titleThree4} />
        </Flex>
      </Box>

      {/* 室内 */}
      <Box 
        ref={snRef}
        className="wow slideInRight"
        data-wow-duration="1s"
        data-wow-delay="1s"
        mb="146px"
      >
        <Flex gap="30px" alignItems="center" mb="40px">
          <Box fontSize="24px" color="#3E3E3E" fontWeight="bold" ml="30px">室内设计</Box>
          <Box fontSize="14px" color="#848484">新中式 &nbsp;&nbsp;&nbsp;&nbsp; 现代简约 &nbsp;&nbsp;&nbsp;&nbsp; 巴洛克 &nbsp;&nbsp;&nbsp;&nbsp; 英伦 &nbsp;&nbsp;&nbsp;&nbsp; 波西米亚</Box>
          <Box flex={1} h="7px" bgColor="#E0E0E0"></Box>
        </Flex>
        <Box>
          <Swiper
            autoPlay={3000} //自动切换间隔时间(ms)
            duration={1000} //切换动画持续时间(ms)
            selectedIndex={0}
            showIndicators={true}
            indicator={null} //两侧翻页按钮
            dots={null}  //底部dots
            showDots={false} //是否显示底部dots
            direction="horizontal" 
            loop={true}
            ref={swiperRef1}
            // onChange={onChange}
          >
            <div>
              <img src={Sn1} style={{width: "50%"}} />
              <img src={Sn2} style={{width: "50%"}} />
            </div>
            <div>
              <img src={Sn3} style={{width: "50%"}} />
              <img src={Sn4} style={{width: "50%"}} />
            </div>
            <div>
              <img src={Sn5} style={{width: "50%"}} />
              <img src={Sn6} style={{width: "50%"}} />
            </div>
            <div>
              <img src={Sn7} style={{width: "50%"}} />
              <img src={Sn8} style={{width: "50%"}} />
            </div>
          </Swiper>
        </Box>
      </Box>
      
      {/* 建筑 */}
      <Box 
        ref={jzRef}
        className="wow slideInLeft"
        data-wow-duration="1s"
        data-wow-delay="1s"
        mb="146px"
      >
        <Flex gap="30px" alignItems="center" mb="40px">
          <Box flex={1} h="7px" bgColor="#E0E0E0"></Box>
          <Box fontSize="14px" color="#848484">别墅建筑 &nbsp;&nbsp;&nbsp;&nbsp; 办公建筑 &nbsp;&nbsp;&nbsp;&nbsp; 观演建筑 &nbsp;&nbsp;&nbsp;&nbsp; 赛博建筑</Box>
          <Box fontSize="24px" color="#3E3E3E" fontWeight="bold" mr="30px">建筑设计</Box>
        </Flex>
        <Box>
          <Swiper
            autoPlay={3000} //自动切换间隔时间(ms)
            duration={1000} //切换动画持续时间(ms)
            selectedIndex={0}
            showIndicators={true}
            indicator={null} //两侧翻页按钮
            dots={null}  //底部dots
            showDots={false} //是否显示底部dots
            direction="horizontal" 
            loop={true}
            ref={swiperRef2}
            // onChange={onChange}
          >
            <div>
              <img src={JZ1} style={{width: "50%"}} />
              <img src={JZ2} style={{width: "50%"}} />
            </div>
            <div>
              <img src={JZ3} style={{width: "50%"}} />
              <img src={JZ4} style={{width: "50%"}} />
            </div>
            <div>
              <img src={JZ5} style={{width: "50%"}} />
              <img src={JZ6} style={{width: "50%"}} />
            </div>
            <div>
              <img src={JZ7} style={{width: "50%"}} />
              <img src={JZ8} style={{width: "50%"}} />
            </div>
          </Swiper>
        </Box>
      </Box>

      {/* 景观 */}
      <Box 
        ref={jgRef}
        className="wow slideInRight"
        data-wow-duration="1s"
        data-wow-delay="1s"
        mb="146px"
      >
        <Flex gap="30px" alignItems="center" mb="40px">
          <Box fontSize="24px" color="#3E3E3E" fontWeight="bold" ml="30px">景观设计</Box>
          <Box fontSize="14px" color="#848484">亭   廊 &nbsp;&nbsp;&nbsp;&nbsp;  阁  &nbsp;&nbsp;&nbsp;&nbsp; 自然主义 &nbsp;&nbsp;&nbsp;&nbsp;  滨水景观  &nbsp;&nbsp;&nbsp;&nbsp; 空间序列 &nbsp;&nbsp;&nbsp;&nbsp; 季相变化</Box>
          <Box flex={1} h="7px" bgColor="#E0E0E0"></Box>
        </Flex>
        <Box>
          <Swiper
            autoPlay={3000} //自动切换间隔时间(ms)
            duration={1000} //切换动画持续时间(ms)
            selectedIndex={0}
            showIndicators={true}
            indicator={null} //两侧翻页按钮
            dots={null}  //底部dots
            showDots={false} //是否显示底部dots
            direction="horizontal" 
            loop={true}
            ref={swiperRef3}
            // onChange={onChange}
          >
            <div>
              <img src={JG1} style={{width: "50%"}} />
              <img src={JG2} style={{width: "50%"}} />
            </div>
            <div>
              <img src={JG3} style={{width: "50%"}} />
              <img src={JG4} style={{width: "50%"}} />
            </div>
            <div>
              <img src={JG5} style={{width: "50%"}} />
              <img src={JG6} style={{width: "50%"}} />
            </div>
            <div>
              <img src={JG7} style={{width: "50%"}} />
              <img src={JG8} style={{width: "50%"}} />
            </div>
          </Swiper>
        </Box>
      </Box>

      {/* 其它 */}
      <Box 
        ref={qtRef}
        className="wow slideInLeft"
        data-wow-duration="1s"
        data-wow-delay="1s"
        mb="146px"
      >
        <Flex gap="30px" alignItems="center" mb="40px" >
          <Box flex={1} h="7px" bgColor="#E0E0E0"></Box>
          <Box fontSize="14px" color="#848484">大赛作品 &nbsp;&nbsp;&nbsp;&nbsp;  CG渲染 &nbsp;&nbsp;&nbsp;&nbsp;  时尚设计  &nbsp;&nbsp;&nbsp;&nbsp; 游戏  &nbsp;&nbsp;&nbsp;&nbsp; 人物  &nbsp;&nbsp;&nbsp;&nbsp; 创意  &nbsp;&nbsp;&nbsp;&nbsp; 平面设计  &nbsp;&nbsp;&nbsp;&nbsp; 海报招贴</Box>
          <Box fontSize="24px" color="#3E3E3E" fontWeight="bold" mr="30px">设计师作品</Box>
        </Flex>
        <Box>
          <Swiper
            autoPlay={3000} //自动切换间隔时间(ms)
            duration={1000} //切换动画持续时间(ms)
            selectedIndex={0}
            showIndicators={true}
            indicator={null} //两侧翻页按钮
            dots={null}  //底部dots
            showDots={false} //是否显示底部dots
            direction="horizontal" 
            loop={true}
            ref={swiperRef4}
            // onChange={onChange}
          >
            <div>
              <img src={QT1} style={{width: "50%"}} />
              <img src={QT2} style={{width: "50%"}} />
            </div>
            <div>
              <img src={QT3} style={{width: "50%"}} />
              <img src={QT4} style={{width: "50%"}} />
            </div>
            <div>
              <img src={QT5} style={{width: "50%"}} />
              <img src={QT6} style={{width: "50%"}} />
            </div>
            <div>
              <img src={QT7} style={{width: "50%"}} />
              <img src={QT8} style={{width: "50%"}} />
            </div>
          </Swiper>
        </Box>
      </Box>

      {/* 右侧悬浮窗 */}
      {showContacts && isInBanner && 
        <Box
          pt={10}
          pb={10}
          sx={{
            width: "76px",
            position: "fixed",
            top: "50%",
            right:0,
            transform: "translateY(-50%)",
            background: "rgba(255, 255, 255, 0.6)",
            backdropFilter: "blur(10px)", /* 背景模糊 */
            zIndex: 99,
            fontSize: "12px",
            color: "#B9B9B9",
            boxShadow:"0px 0px 8px 5px rgba(255, 255, 255, 0.5)"
        }}>
          <Box>
            <VStack align="center" mb={10} cursor="pointer">
              <Image flexShrink={0} maxW="100%" src={xfIcon1} />
            </VStack>
            <VStack align="center" mb={10} cursor="pointer" onClick={()=>messageControl.onOpen()}>
              <Image src={xfIcon2} />
              <Text>消息</Text>
            </VStack>
            <VStack align="center" mb={10} cursor="pointer">
              {/* <Image src={xfIcon3} />
              <Text>客服</Text> */}
              <CustomerService />
            </VStack>
            
            <VStack align="center" mb={10} cursor="pointer">
              <Image src={xfIcon4} />
              <Text>使用帮助</Text>
            </VStack>
            <VStack align="center" mb={10} cursor="pointer">
              {/* <Image src={xfIcon5} />
              <Text>问题反馈</Text> */}
              <FeedbackPopover />
            </VStack>
            <VStack align="center" cursor="pointer">
              <Image src={xfIcon6} onClick={handleScrollToTop} />
            </VStack>
          </Box>
        </Box>
      } 
      <MessageMenu isOpen={messageControl.isOpen} onClose={messageControl.onClose}  />
    </Box>
  );
};

export default Home;
